<template>
  <div>
    <div v-if="filter_active">
      <div class="row">
        <div class="col-lg-12">
          <operation-basic-information v-bind:api_data="api_data"></operation-basic-information>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="row">
        <div class="col-lg-12">
          <operation-basic-information v-bind:api_data="api_data"></operation-basic-information>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12">
          <operation-family-information v-bind:api_data="api_data"></operation-family-information>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12">
          <operation-gov-scheme-information v-bind:api_data="api_data"></operation-gov-scheme-information>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12">
          <operation-land-information v-bind:api_data="api_data"></operation-land-information>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12">
          <operation-livelihood-information v-bind:api_data="api_data"></operation-livelihood-information>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12">
          <operation-cultivation-information v-bind:api_data="api_data"></operation-cultivation-information>
        </div>
      </div>
    </div>
    <div v-on:click="storeData" class="in_edit_button">
      <div>
        <vue-fab mainBtnColor="#3599DB">
          <v-btn class="mx-2" fab dark large color="purple">
            <div v-if="filter_active">
              {{ $t('Apply') }}
            </div>
            <div v-else>
              {{ $t('Save') }}
            </div>
          </v-btn>
        </vue-fab>
      </div>
    </div>
  </div>
</template>
<style>
.fab-cantainer.fab.fab-size-normal {
  display: none;
}
</style>
<script>
import {FARMER_CREATE, FARMER_SINGLE, FARMER_SINGLE_UPDATED, FARMER_STORE} from "@/core/services/store/farmer.module";
import {ADD_BODY_CLASSNAME, REMOVE_BODY_CLASSNAME} from "@/core/services/store/htmlclass.module";

export default {
  name: "edit",
  beforeMount() {
    this.$store.dispatch(ADD_BODY_CLASSNAME, "page-loading");
    this.$toast.open(this.$t('Data Loading'));
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.getSingle(vm)
      localStorage.setItem('last_show_opened_record', vm.$route.params.id)
    });
  },
  methods: {
    getSingle(vm = null) {
      if (!vm) {
        vm = this;
      }
      try {
        var filter_active_data = localStorage.getItem('filter_active_data');
        if (vm.filter_active && filter_active_data) {
          filter_active_data = JSON.parse(filter_active_data);
          if (filter_active_data) {
            vm.api_data = {Farmer: filter_active_data};
          }
          this.$nextTick(() => this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading"));
          return true;
        }
      } catch (e) {
      }
      if (vm.$route.params.id) {
        vm.$store.dispatch(FARMER_SINGLE, {id: vm.$route.params.id}).then(value => vm.api_data = {Farmer: value})
            .then(() => this.$nextTick(() => this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading")));
      } else {
        let get_latest = true;
        if (vm.filter_active) {
          get_latest = false;
        }
        vm.$store.dispatch(FARMER_CREATE, get_latest).then(value => vm.api_data = {Farmer: value})
            .then(() => this.$nextTick(() => this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading")));
      }
    },
    async storeData() {
      this.$emit('storeData', this.api_data.Farmer);
      if (this.filter_active) {
        localStorage.setItem('filter_active_data', JSON.stringify(this.api_data.Farmer));
      } else {
        let id = this.api_data.Farmer.id;
        if (id) {
          await this.$store.dispatch(FARMER_SINGLE_UPDATED, this.api_data.Farmer);
        } else {
          await this.$store.dispatch(FARMER_STORE, this.api_data.Farmer);
          id = this.$store.getters.getStoreFarmer.id;
        }
        this.$router.push({name: 'farmer-show', params: {id: id}});
      }
    }
  },
  props: {
    filter_active: {
      type: Boolean
    }
  },
  data() {
    return {
      api_data: {
        Farmer: {}
      }
    };
  },
};
</script>
